export class EventEmitter {
  constructor() {
    this.listeners = {};
  }

  subscribe(event, callback) {
    if (this.listeners[event]) {
      this.listeners[event].push(callback);
    } else {
      this.listeners[event] = [callback];
    }
  }

  emit(event, data) {
    if (!this.listeners[event]) {
      return;
    }
    this.listeners[event].forEach(callback => callback(data));
  }

  unsubscribe(event, callback) {
    this.listeners[event] = (this.listeners[event] || []).filter(
      c => c != callback
    );
  }
}

export default new EventEmitter();
